import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import {
  dowloadData,
  getStringToBoolean,
  getUrlObjectsQr,
} from "../../../utils/functions";
import { Link } from "react-router-dom";
import { useAllObjects } from "../../../hooks/BO/useAllObjects";
import { ButtonCustom } from "../../Common.styled";
import { menuOptionBO } from "../../../utils/constants";

export const TableObjets = () => {
  const { data, isLoading: isLoadinTable } = useAllObjects();

  return (
    <>
      <ButtonCustom onClick={() => dowloadData(data, menuOptionBO?.objects)}>
        Descargar txt
      </ButtonCustom>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Disponible</TableCell>
              <TableCell>Usuario</TableCell>
              <TableCell>Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoadinTable ? (
              <div>
                <CircularProgress size={40} />
              </div>
            ) : (
              data?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    {getStringToBoolean(item?.created?.toString())
                      ? "No"
                      : "Si"}
                  </TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>
                    <Link to={getUrlObjectsQr(item.id)}>Ir a la pagina</Link>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
